import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";
import AppPreloader from "@src/Components/Common/AppPreloader/AppPreloader";
import { STTabsContentWrapper, STFormContentWrapper } from "./styles";
import { Grid, Tabs, Tab } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import AuthApplications from "./AuthApplications/AuthApplications";
import { IValuesStore, IRoles } from "@src/Stores/Values/types";
import { IAuthStore } from "@src/Stores/Auth/types";
import AuthProviders from './AuthProviders/AuthProviders';

interface IProps {
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("auth", "values")
@observer
export default class OAuth extends React.Component<IProps> {
  @observable isLoading: boolean = true;
  @observable tabIndex: number = 0;
  @observable providersTabIndex: number;
  @observable applicationsTabIndex: number;

  async componentDidMount() {
    this.providersTabIndex = 0;
    this.applicationsTabIndex = this.props.auth.user.location.primary ? 1 : 0;
    this.isLoading = false;
    document.title = Values.getLocalizationValue("oAuth");
  }

  handleTabIndexChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.tabIndex = newValue;
  };

  render() {
    if (this.isLoading) {
      return <AppPreloader />;
    }

    const userRoles = this.props.auth.user.roles;
    const rolesList: IRoles = this.props.values.roles;
      userRoles.includes(rolesList.Administrator);

    return (
      <Grid container justify="center">
        <Grid item xs={12}>
          <STPageHeader>{Values.getLocalizationValue("oAuth")}</STPageHeader>
        </Grid>
        <STTabsContentWrapper>
          <Tabs
            value={this.tabIndex}
            onChange={this.handleTabIndexChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            {this.props.auth.user.location.primary && <Tab label={Values.getLocalizationValue("providers")} />}
            <Tab label={Values.getLocalizationValue("applications")} />
          </Tabs>
          <STFormContentWrapper>
            {this.tabIndex === this.providersTabIndex && this.props.auth.user.location.primary && (
              <div>
                <AuthProviders />
              </div>
            )}
            {this.tabIndex === this.applicationsTabIndex && (
              <div>
                <AuthApplications />
              </div>
            )}
          </STFormContentWrapper>
        </STTabsContentWrapper>
      </Grid>
    );
  }
}
